import React from 'react'
import ReactDOM from 'react-dom'
import './styles/index.css'
import App from './components/App'
import Header from './components/Header'
import rootReducer from './redux/index'
// import registerServiceWorker from './registerServiceWorker'
import { createStore, applyMiddleware } from 'redux' // 01
import { Provider } from 'react-redux' // 02
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import Login from './components/Login'
import LoadingComponent from './components/LoadingComponent'
import AuthComponent from './components/AuthComponent'
import 'react-rain-animation/lib/style.css';
import NoteDetail from './components/NoteDetail'
import NoteEdit from './components/NoteEdit'

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
)

const phoenix = (
  <div>
    <Header />
    <App />
  </div>
)

const noteEdit = (
  <div>
    <Header />
    <NoteEdit/>
  </div>

)

const phoenixNoteDetail = (
  <div>
    <Header />
    <NoteDetail/>
  </div>
)

const login = (
  <div className='particles'>
    <Login />
  </div>
)

// provide the store to react

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <LoadingComponent>
        <div>
          <Switch>
            {/*<Route path="/login" component={Login} exact={true} />*/}
            <Route path="/login" render={() => login} exact={true} />
            { /* Duplicating for ghPages */ }
            <Route path="/inCyberNotes/login" render={() => login} exact={true} />
            { /* Duplicating for ghPages end*/ }
            <Redirect from="/logout" to="/inCyberNotes/login" />
            <AuthComponent>
              <Route path="/" render={() => phoenix} exact={true} />
              <Route path="/login" render={() => phoenix} exact={true} />
              <Route path="/inCyberNotes" render={() => phoenix} exact={true} />
              <Route path="/inCyberNotes/:id/edit" render={()=> noteEdit} exact={true} />
              <Route path="/inCyberNotes/:id" render={()=> phoenixNoteDetail} exact={true} />
            </AuthComponent>
          </Switch>
        </div>
      </LoadingComponent>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)




// WEBPACK FOOTER //
// ./src/index.js